export class MasterPlanLocationFilter {
  id!: string;
  filterValue!: string[];
  filterTypeId!: string;
  filterFieldId!: string;
  planContainerId!: string;
  sequenceNumber!: number;

}
